import { Action, Dispatch } from 'redux'
import { push } from 'connected-react-router'
import { db } from 'firebase/index'
import { BreadType } from 'types/bread'
import { StockType } from 'types/stock'
import { OrderType } from 'types/checkout'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'

const deleteDeliveryStocks = (bread: BreadType, stocks: StockType[], orders: OrderType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const batch = db.batch()
    for (let i = 0; i < stocks.length; i = (i + 1) | 0) {
      const stock = stocks[i]
      if (!stock.stock_ref) continue
      // 予約注文のある日付の在庫は削除しない
      if (orders.some((order) => order.date === stock.date)) continue
      batch.delete(stock.stock_ref)
    }
    try {
      await batch.commit()
      dispatch(hideLoadingAction())
      const url = `/schedule/delivery/${bread.bread_ref?.id}/delete`
      dispatch(push(url))
    } catch (e) {
      console.error(e)
      dispatch(hideLoadingAction())
    }
  }
}

export default deleteDeliveryStocks
